// Shared message protocol between the device SharedWorker and its
// main-thread clients. Importing from here is safe from any context
// (browser main thread, SharedWorker, Gatsby SSR) because nothing in
// this file touches browser-only globals. The worker body itself
// (deviceWorker.ts) has top-level side effects (self.onconnect = ...)
// and must never be imported as a runtime value — only the worker
// loader in deviceWorkerClient.ts references it, and only via
// `new URL('./deviceWorker.ts', import.meta.url)`.

export type WorkerRequest =
    | { id: number; cmd: 'unlock'; masterKeyHex: string }
    | { id: number; cmd: 'decryptWithMasterKey'; envelopeB64: string }
    | { id: number; cmd: 'encryptWithMasterKey'; plaintextB64: string }
    | { id: number; cmd: 'isUnlocked' }
    | { id: number; cmd: 'lock' }
    // Protocol sanity probe: returns the worker's own DEVICE_WORKER_NAME
    // so the client can catch a stale SW after an incompatible bump.
    | { id: number; cmd: 'ping' }

export type WorkerResponse =
    | { id: number; ok: true; data?: any }
    | { id: number; ok: false; error: string }

// SharedWorker name. Browsers uniquely identify a SharedWorker by
// (scriptURL, name) — so bumping this spawns a fresh worker instance
// even if the URL didn't change (which happens when webpack chunks
// aren't content-hashed in dev).
//
// IMPORTANT: bump this suffix whenever the WorkerRequest / WorkerResponse
// protocol changes in a way that's incompatible with the previous
// version (renamed commands, changed field shapes, new required
// arguments, etc.). Without the bump, a tab still holding a live
// reference to the old worker from before the deploy will keep
// routing new clients to stale code, and they'll see "unknown cmd"
// errors that only clear after every tab of the origin is closed.
export const DEVICE_WORKER_NAME = 'practicemd-device-v2'
